var styles = {
  "Blur": "_Blur_m9tly_1",
  "Button": "_Button_m9tly_9"
};

export { styles as default };
